import { useCallback, useEffect, useMemo, useState } from "react";
import Popover from "@mui/material/Popover";
import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, Typography } from "@mui/material";
import { axiosInstance } from "../../utility/apiInstance";
import SubscriptionForm from "./SubscriptionForm";
import Milestone from "./MileStone";
import DialogBox from "../../page/Awbtrackedlist/DialogBox";
import { useRole } from "../MangeContextProvide";
import toast from "react-hot-toast";
import SearchInput from "../../common/SearchInput";

const PAGE_SIZE = 10;

export default function SubscriptionDataTable() {
  const { globleCustomerId } = useRole() as any;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [modalPopup, setmodalPopup] = useState({
    subcriptionPopup: false,
    mileStonePopup: false,
  });
  const [subscriptionFormData, setSubscriptionFormData] = useState({
    awbs: [],
    whatsApp: [],
    emails: [],
    whatsAppmilestones: [],
    emailsmilestones: [],
    milestoneList: [],
    mileStoneType: "",
    manageContactList: [],
    subscriptionList: [],
    templateList: [],
    templateName: {},
    whatsappGroupList: [],
    whatsAppgroups: [],
    whatsappGroupmilestones: [],
  }) as any;
  const [editable, setEditable] = useState(false);
  const [editData, setEditData] = useState(null) as any;
  const [errorList, setErrorList] = useState(null);
  const [show, setShow] = useState(false);
  const [statusMessage, setStatusMessage] = useState({}) as any;
  const { milestoneList, manageContactList, subscriptionList } =
    subscriptionFormData;

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  // popover for contacts / milestones lists
  const [popover, setPopover] = useState<{ anchor: HTMLElement; content: any } | null>(null);

  // debounce search effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  // Fix the debounced effect — pass the string directly
  useEffect(() => {
    getAllSubscription(debouncedSearch);
  }, [debouncedSearch]);

  // reset to first page when the search changes
  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedSearch]);

  useEffect(() => {
    getAllSubscription(debouncedSearch);
    getAllAirBill();
  }, [loading]);

  const getAllAirBill = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/airwaybill/get-awb");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: response?.data?.data,
        };
      });
    } catch (err) { }
  };
  const updateSubscriptionFormData = useCallback(
    async (data: any) => {
      setSubscriptionFormData((prev: any) => {
        const { contacts, whatsappGroup } = data?.row;
        return {
          ...prev,
          whatsApp: contacts
            ?.filter(
              (item: any) =>
                data?.row?.alertType === "whatsapp" &&
                contacts
                  ?.map((contact: any) => contact?._id)
                  .includes(item?._id)
            )
            .map((item: any) => ({
              label: item?.name,
              value: item._id,
            })),
          emails: contacts
            ?.filter(
              (item: any) =>
                data?.row?.alertType === "email" &&
                contacts
                  ?.map((contact: any) => contact?._id)
                  .includes(item?._id)
            )
            .map((item: any) => ({
              label: item?.name,
              value: item._id,
            })),
          awbs: prev.subscriptionList
            ?.filter((option: any) =>
              option?.awbNumber?.includes(data?.row?.awbNumber)
            )
            ?.map((item: any) => ({
              label: item.awbNumber,
              value: item.awbNumber,
            })),
          whatsAppmilestones:
            (data?.row?.alertType === "whatsapp" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
          emailsmilestones:
            (data?.row?.alertType === "email" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
          whatsAppgroups:
            (data?.row?.alertType === "whatsappgroup" &&
              whatsappGroup?.map((item: any) => ({
                label: item.name,
                value: item._id,
              }))) ||
            [],
          whatsappGroupmilestones:
            (data?.row?.alertType === "whatsappgroup" &&
              data?.row?.milestones?.map((milestone: any) => milestone._id)) ||
            [],
        };
      });
      setEditData(data);
      setEditable(true);
      getAllMileStone(data?.row?.awbNumber);
      setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }));
    },
    [editData, editable]
  );

  const getAllSubscription = async (search: string = "") => {
    setTableLoading(true);
    try {
      let response = await axiosInstance.get(
        `/api/v1/subscription/all-subscriptions?search=${search}`
      );
      setRows(response?.data?.data);
    } catch (err) {
      toast.error("Failed to fetch subscriptions");
    } finally {
      setTableLoading(false);
    }
  };

  const addSubscription = async () => {
    setLoading(true);
    const { whatsAppmilestones, emailsmilestones, whatsappGroupmilestones } =
      subscriptionFormData;

    const whatApps = subscriptionFormData.whatsApp?.map(
      (item: any) => item.value
    );
    const whatsappGroups = subscriptionFormData.whatsAppgroups?.map(
      (item: any) => item.value
    );
    const emails = subscriptionFormData.emails?.map((item: any) => item.value);
    const awbs = [subscriptionFormData.awbs]?.map((item: any) => item.value);
    try {
      let response = editable
        ? await axiosInstance.post(
          `/api/v1/subscription//update-subscription/${editData?.row?._id}`,
          {
            awbs,
            whatApps,
            emails,
            whatsAppmilestones,
            emailsmilestones,
            whatsappGroups,
            whatsappGroupMilestones: whatsappGroupmilestones,
          }
        )
        : await axiosInstance.post("/api/v1/subscription/create-subscription", {
          awbs,
          whatApps,
          emails,
          whatsAppmilestones,
          emailsmilestones,
          whatsappGroups,
          whatsappGroupMilestones: whatsappGroupmilestones,
        });
      if (!editable) {
        if (response.data.message.messageStatus === 1) {
          setStatusMessage(response?.data?.message);
          setShow(true);
          setSubscriptionFormData((prev: any) => ({
            ...prev,
            mileStoneType: "",
            awbs: [],
            whatsApp: [],
            emails: [],
            whatsAppmilestones: [],
            emailsmilestones: [],
            templateName: {},
            whatsappGroups: [],
            whatsappGroupMilestones: [],
          }));
        } else {
          setStatusMessage(response?.data?.message);
        }

        if (response.data.data.failed?.length > 0) {
          setErrorList(
            response.data.data.failed?.map((item: any) => ({
              awb: item?.awbNumber,
              reason: item?.reason,
            }))
          );
          setShow(true);
          setLoading(false);
          return;
        }
      } else {
        toast.success(response.data.message)
        setSubscriptionFormData((prev: any) => ({
          ...prev,
          mileStoneType: "",
          awbs: [],
          whatsApp: [],
          emails: [],
          whatsAppmilestones: [],
          emailsmilestones: [],
          templateName: {},
          whatsAppgroups: [],
          whatsappGroupMilestones: [],
        }));
      }
      setLoading(false);
      setEditData({});
      setEditable(false);
      setmodalPopup({
        subcriptionPopup: false,
        mileStonePopup: false,
      });

    } catch (error: any) {
      setLoading(false);
      setStatusMessage({});
      if (error.response?.data.error?.length > 0) {
        setErrorList((): any => {
          const errorlog = Array.isArray(error.response.data.error)
            ? error.response.data.error.map((err: any) => {
              return {
                awb: "",
                reason: err.message,
              };
            })
            : [{ awb: "", reason: error.response.data.error }];
          return errorlog;
        });
        setShow(true);
        return;
      }
    }
  };

  const deleteSubscription = async (
    id: string,
    awbNumber: string,
    contactId: string,
    channel: string
  ) => {
    try {
      let response = await axiosInstance.post(
        `/api/v1/subscription/delete-subscription/${awbNumber}`,
        {
          contactId,
          channel,
        }
      );
      setRows((prevRows) => prevRows.filter((row: any) => row._id !== id));
      toast.success(response.data.message)
    } catch (err: any) {
      toast.error(err?.response?.data?.error || "Failed to delete")
    }
  };
  const editSubscription = async (data: any) => {
    updateSubscriptionFormData(data);
  };

  const getAllMileStone = async (awb: string) => {
    try {
      let response = await axiosInstance.get(`/api/v1/mileStone/${awb}`);

      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          milestoneList: response?.data?.data,
        };
      });
    } catch (err) { }
  };

  const handleAwbChange = useCallback(
    (awb: string) => {
      return getAllMileStone(awb);
    },
    [subscriptionFormData.awbs]
  );

  // Mirrors the old ModalPopup handleClose behavior exactly.
  const drawerOpen = modalPopup.subcriptionPopup || modalPopup.mileStonePopup;
  const handleDrawerClose = () => {
    // If the milestone step is open, closing should return to the form,
    // not dismiss the whole drawer.
    if (modalPopup.mileStonePopup) {
      setmodalPopup((prev) => ({
        ...prev,
        subcriptionPopup: true,
        mileStonePopup: false,
      }));
      return;
    }
    // Form step open → fully close and reset.
    setmodalPopup((prev) => ({
      ...prev,
      subcriptionPopup: false,
      mileStonePopup: false,
    }));
    setSubscriptionFormData((prev: any) => ({
      ...prev,
      mileStoneType: "",
      awbs: [],
      whatsApp: [],
      emails: [],
      whatsAppmilestones: [],
      emailsmilestones: [],
      templateName: {},
      milestoneList: [],
    }));
  };

  // ── Created-at formatting (unchanged from the old renderCell) ─────
  const formatCreatedAt = (value: any) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    const date = `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
    const time = `${String(d.getHours()).padStart(2, "0")}:${String(
      d.getMinutes()
    ).padStart(2, "0")}`;
    return `${date} ${time}`;
  };

  // ── Row mapping (server shape → view shape) ─────────────────────
  const mappedRows = useMemo(
    () =>
      (rows || []).map((item: any) => {
        const contactNames = item?.contacts?.length
          ? item.contacts.map((c: any) => c?.name).filter(Boolean)
          : (item?.whatsappGroup?.map((g: any) => g?.name).filter(Boolean) || []);
        const milestoneLabels =
          item?.milestones?.map((m: any) => m?.label).filter(Boolean) || [];
        return {
          ...item,
          salutation: item?.alertType || "-",
          contactNames,
          milestoneLabels,
        };
      }),
    [rows]
  );

  const pageCount = Math.max(1, Math.ceil(mappedRows.length / PAGE_SIZE));
  const pagedRows = mappedRows.slice(
    currentPage * PAGE_SIZE,
    currentPage * PAGE_SIZE + PAGE_SIZE
  );

  // ── Popover helper ────────────────────────────────────────────────
  const showListPopover = (
    e: React.MouseEvent<HTMLElement>,
    title: string,
    icon: string,
    items: string[]
  ) => {
    setPopover({
      anchor: e.currentTarget,
      content: (
        <>
          <div className="ctpl-popover-title">{icon} {title}</div>
          <ul className="ctpl-popover-list">
            {items.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </>
      ),
    });
  };

  const renderContacts = (names: string[]) => {
    if (!names.length) return "-";
    const shown = names.slice(0, 2);
    const extra = names.length - 2;
    return (
      <>
        {shown.map((n: string, i: number) => (
          <span className="ctpl-flag-chip" key={i}>{n}</span>
        ))}
        {extra > 0 && (
          <button
            type="button"
            className="ctpl-flag-more"
            aria-label={`Show all contacts (${names.length})`}
            onClick={(e) => showListPopover(e, `Contacts (${names.length})`, "👤", names)}
          >
            +{extra}
          </button>
        )}
      </>
    );
  };

  const renderMilestones = (labels: string[], channel: string) => {
    if (!labels.length) return "-";
    let icons = "💬"
    if (channel === "email") {
      icons = "✉️"
    } else {
      icons = "💬"
    }
    return (
      <button
        type="button"
        className="ctpl-channel-badge"
        onClick={(e) => showListPopover(e, `Milestones (${labels.length})`, icons, labels)}
      >
        {icons} {labels.length}
      </button>
    );
  };

  return (
    <>
      <div className="ctpl-card">
        <div className="ctpl-toolbar">
          <SearchInput
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search…"
          />

          <div className="ctpl-spacer" />

          <button
            className="ctpl-btn ctpl-btn-primary"
            onClick={() => {
              setmodalPopup((prev) => ({ ...prev, subcriptionPopup: true }));
              setEditable(false);
              setEditData({});
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Add Subscription
          </button>
        </div>

        <div className="ctpl-table-scroll">
          <table className="ctpl-table">
            <thead>
              <tr>
                <th style={{ width: "13%" }}>Added By</th>
                <th style={{ width: "13%" }}>Create At</th>
                <th style={{ width: "13%" }}>MAWB</th>
                <th style={{ width: "15%" }}>Organization Name</th>
                <th style={{ width: "4%" }}>Channel</th>
                <th style={{ width: "15%" }}>Contacts</th>
                <th style={{ width: "10%" }}>Miletones</th>
                <th style={{ width: "10%", textAlign: "right", paddingRight: 22 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr><td className="ctpl-empty-cell" colSpan={8}>Loading subscriptions…</td></tr>
              ) : pagedRows.length === 0 ? (
                <tr><td className="ctpl-empty-cell" colSpan={8}>No subscriptions found</td></tr>
              ) : (
                pagedRows.map((row: any) => {
                  const contactId = row.contacts?.[0]?._id;
                  const isOwner = row.customerId?._id === globleCustomerId;
                  return (
                    <tr key={row._id}>
                      <td>{row.addedBy || "-"}</td>
                      <td>{formatCreatedAt(row.createdAt)}</td>
                      <td>{row.awbNumber || "-"}</td>
                      <td>{row.organizationName || "-"}</td>
                      <td>
                        <span className="ctpl-flag-chip">{row.salutation}</span>
                      </td>
                      <td>{renderContacts(row.contactNames)}</td>
                      <td>{renderMilestones(row.milestoneLabels, row.salutation)}</td>
                      <td>
                        {isOwner ? (
                          <div className="ctpl-row-actions">
                            <button
                              className="ctpl-action-circle edit"
                              title="Edit"
                              onClick={() => editSubscription({ row })}
                            >
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 20h9" />
                                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
                              </svg>
                            </button>
                            <button
                              className="ctpl-action-circle delete"
                              title="Delete"
                              onClick={() =>
                                deleteSubscription(row._id, row.awbNumber, contactId, row.alertType)
                              }
                            >
                              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0-1 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 6" />
                              </svg>
                            </button>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className="ctpl-table-footer">
          <span>{mappedRows.length} subscription{mappedRows.length === 1 ? "" : "s"}</span>
          <div className="ctpl-pagination">
            <button className="ctpl-page-btn" disabled={currentPage === 0} onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}>‹</button>
            <span>Page {currentPage + 1} of {pageCount}</span>
            <button className="ctpl-page-btn" disabled={currentPage >= pageCount - 1} onClick={() => setCurrentPage((p) => Math.min(pageCount - 1, p + 1))}>›</button>
          </div>
        </div>
      </div>

      {/* ── Drawer (replaces ModalPopup — same open/close behavior & children) ── */}
      <div
        className={`ctpl-overlay${drawerOpen ? " open" : ""}`}
        onClick={handleDrawerClose}
      />
      <div className={`ctpl-drawer ctpl-drawer-wide${drawerOpen ? " open" : ""}`}>
        <div className="ctpl-drawer-header">
          <h2>
            {modalPopup.mileStonePopup
              ? "Include / Exclude Milestones"
              : editable
                ? "Edit Subscription"
                : "Add Subscription"}
          </h2>
          <button className="ctpl-icon-btn" onClick={handleDrawerClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="ctpl-drawer-body">
          {modalPopup.subcriptionPopup ? (
            <SubscriptionForm
              type="Awb"
              subscriptionFormData={subscriptionFormData}
              manageContactList={manageContactList}
              setmodalPopup={setmodalPopup}
              setSubscriptionFormData={setSubscriptionFormData}
              subscriptionList={subscriptionList}
              loading={loading}
              addSubscription={addSubscription}
              editable={editable}
              editData={editData}
              getAllMileStone={handleAwbChange}
              whatsappGroupList={subscriptionFormData.whatsappGroupList}
            />
          ) : (
            <Milestone
              subscriptionFormData={subscriptionFormData}
              milestoneList={milestoneList}
              setSubscriptionFormData={setSubscriptionFormData}
              onclose={() =>
                setmodalPopup((prev) => ({
                  ...prev,
                  subcriptionPopup: true,
                  mileStonePopup: false,
                }))
              }
            />
          )}
        </div>
      </div>

      <DialogBox
        open={show}
        successMessage={
          <DialogTitle>
            <Typography
              variant="h6"
              className={`font-semibold ${statusMessage?.messageStatus === 1
                ? "text-green-500"
                : "text-red-500"
                }`}
            >
              {statusMessage?.message}
            </Typography>
          </DialogTitle>
        }
        handleClose={() => {
          setShow(false);
          setErrorList(null);
        }}
        data={errorList}
      />

      <Popover
        open={!!popover}
        anchorEl={popover?.anchor}
        onClose={() => setPopover(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{ className: "ctpl-popover-paper" }}
      >
        {popover?.content}
      </Popover>
    </>
  );
}